import { renderRoutes, Router } from '@fishx/router'
import React from 'react'

import Fishx from '@fishx/core'

import { Provider } from 'react-redux'
import dva from '@fishx/dva'
import models from './models'

const store = dva({
  models,
  initialState: {},
  history: Fishx.history,
}).getStore()
Fishx.updateConfig({ store })

export default class RouterWrapper extends React.Component<{
  wrapComponent: any
  history: any
  pathname?: string
  pageInitialProps?: any
}> {
  constructor(props) {
    super(props)
  }

  render() {
    // @ts-ignore
    const {
      wrapComponent: WrapComponent,
      pathname,
      pageInitialProps,
      history,
      routes,
      ...restProps
    } = this.props
    return (
      <Provider store={store}>
        <Router history={history}>
          <WrapComponent>{renderRoutes(routes, restProps)}</WrapComponent>
        </Router>
      </Provider>
    )
  }
}
